const settings = {
  MAIN_COLOR: "rgb(0, 33, 64)",
  CUBEJS_API_URL:
    process.env.REACT_APP_CUBE_API || "https://api.valuedraw.com/cubejs-api/v1",
  // Backend endpoint for fetching Cube.js tokens
  // Supports REACT_APP_CUBEJS_BE_API_URL (CRA), legacy REACT_BE_API_URL, or default
  CUBEJS_BE_API_URL:
    process.env.REACT_APP_CUBEJS_BE_API_URL ||
    process.env.REACT_BE_API_URL ||
    "https://api-auth.valuedraw.com/auth/cubejs-token",
  // Backend base URL for other API operations (e.g., card scanning)
  // Supports REACT_APP_API_BE_BASE_URL (CRA), legacy API_BE_BASE_URL, or default
  API_BE_BASE_URL:
    process.env.REACT_APP_API_BE_BASE_URL ||
    process.env.API_BE_BASE_URL ||
    "https://api-auth.valuedraw.com",
};
export default settings;
